import * as TooltipPrimitive from "@radix-ui/react-tooltip"
import * as React from "react"

import { cn } from "@/lib/utils"
const TooltipProvider = TooltipPrimitive.Provider
const Tooltip = TooltipPrimitive.Root
const TooltipTrigger = TooltipPrimitive.Trigger
const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<
    typeof TooltipPrimitive.Content
  >
>(({ className, sideOffset = 4, ...props }, ref) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        // Fundo/texto do POPOVER, não do primary: o primary do tema é verde limão
        // (hsl 86 72% 48%) e com text-primary-foreground (branco) dava 1,64:1 de
        // contraste — texto ilegível, o tooltip parecia vazio. O par popover é
        // escuro-sobre-claro (e invertido no dark), passando o AA de 4.5:1 exigido
        // pela regra 10 de acessibilidade. Borda + sombra separam do conteúdo atrás.
        "z-50 max-w-xs overflow-hidden rounded-md border bg-popover px-3 py-1.5 text-xs leading-relaxed text-popover-foreground shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        className
      )}
      {...props}
    />
  </TooltipPrimitive.Portal>
))
TooltipContent.displayName =
  TooltipPrimitive.Content.displayName
export {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
}
